module.exports = __webpack_public_path__ + "static/media/aboutac.0ca791da.png";